





























































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import QTableHeader from "@/common/qTableHeader.vue";
import QPaginate from "@/common/qPaginate.vue";
import PaginateModel from "@/model/paginate";
import Multiselect from "vue-multiselect";
import QCalendar from "@/common/qCalendar.vue";
import Article, { STATUS, STATUS_ARRAY, STATUS_CSS } from "@/model/article";
import { BlogManagerArticleService } from "@/common/api/services/BlogManagerArticleService";
import {
  PostGroupManagerPostGroupDTO,
  BlogManagerBlogManagerArticleLikeDTO,
  BlogManagerBlogManagerArticlePageViewDTO,
  AuthUserDTO,
} from "@/common/api";
import { UserDTO } from "@/model/user";

const auth = namespace("Auth");

@Component({
  name: "BlogIndex",
  components: {
    QTableHeader,
    QPaginate,
    Multiselect,
    QCalendar,
  },
})
export default class BlogIndex extends Vue {
  @auth.Getter
  getUsingGroup!: number;

  public initSearch = {
    status: [],
    userId: [],
    title: "",
    postDateStart: "",
    postDateEnd: "",
    sort: "open_satatus",
    direction: "asc",
    perPage: "50",
    currentPage: "1",
  };
  public searchParams = {
    status: [],
    userId: [],
    title: "",
    postDateStart: "",
    postDateEnd: "",
    sort: "",
    direction: "",
    perPage: "",
    currentPage: "",
  };
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
    perPage: 50,
  });
  public headers = [
    { id: "open_satatus", name: "ステータス", order: "asc" },
    { id: "created_at", name: "作成日", order: "asc" },
    { id: "post_date", name: "公開日", order: "desc" },
    { id: "title", name: "タイトル" },
    { id: "release_setting", name: "公開制限範囲" },
    { id: "user_name", name: "作成者" },
    { id: "preview", name: "表示回数" },
    { id: "like_count", name: "いいね件数" },
    { id: "", name: "" },
  ];
  public statuses = STATUS_ARRAY;
  public articles: Article[] = [];
  public users: AuthUserDTO[] = [];
  public selectedStatus: typeof STATUS_ARRAY = [];
  public selectedUser: AuthUserDTO[] = [];
  public dateConfig = {};

  mounted() {
    this.clearSearch();
    this.filter();
  }

  public clearSearch() {
    this.searchParams = { ...this.initSearch };
    this.selectedStatus = [];
    this.selectedUser = [];
  }

  public filter(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }
    query = {
      ...query,
      ...this.searchParams,
      ...addition,
    };
    query.groupId = this.getUsingGroup.toString();
    this.$router
      .replace({ name: name || "", params: params, query })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public doSearch(query: any): void {
    this.getList(query);
    const tableElement = this.$el.querySelector(".mb__responsive-table");
    if (tableElement) {
      tableElement.scrollTop = 0;
    }
  }

  public async getList(query: any) {
    const result = await BlogManagerArticleService.groupAdminArticle(query);
    if (!result.data) {
      // @TODO: Processing when the response is empty
      return;
    }
    this.pagination = new PaginateModel({
      page: result.data.paginator.currentPage,
      pageCount: result.data.paginator.lastPages,
      start: result.data.paginator.currentPage,
      end: result.data.paginator.lastPages,
      count: result.data.paginator.total,
      perPage: result.data.paginator.perPage,
    });
    this.articles = result.data.articles.map((item) => new Article(item));
    this.users = result.data.users;
  }

  public resetSearch() {
    this.clearSearch();
    this.filter(true);
  }

  public changeStatus(value) {
    this.searchParams.status = value.map((item) => item.id);
  }

  public changeUser(value) {
    this.searchParams.userId = value.map((item) => item.id);
  }

  public isStatusChecked(value: any): boolean {
    return this.selectedStatus.some((status) => value.id == status.id);
  }

  public isUserChecked(value: any): boolean {
    return this.selectedUser.some((user) => value.id == user.id);
  }

  public createBlog() {
    this.$router.push({ name: "admin.blog-create" });
  }

  public editBlog(articleId) {
    this.$router.push({
      name: "admin.blog-edit",
      params: {
        id: articleId,
      },
    });
  }

  public getSelectedStatus(items): string {
    if (items.length === 0) {
      return "";
    }
    let names: string[] = [];
    for (const item of items) {
      names.push(item.name);
    }
    return names.join();
  }

  public getStatus(item): string {
    if (item.open_satatus === STATUS.OPEN) {
      let date = new Date(item.post_date);
      let today = new Date();
      if (date > today) {
        return STATUS.WAIT;
      }
    }
    return STATUS_CSS[item.open_satatus];
  }

  public getPostGroupName(array: PostGroupManagerPostGroupDTO[]): string {
    if (array.length === 0) {
      return "";
    }
    let names: string[] = [];
    for (const value of array) {
      names.push(value.name);
    }
    return names.join();
  }

  public getPageview(array: BlogManagerBlogManagerArticlePageViewDTO): number {
    return array.preview;
  }

  public getLike(array: BlogManagerBlogManagerArticleLikeDTO): number {
    return array.like_count;
  }

  public getName(user: UserDTO): string {
    if (!user || !user.name) {
      return "";
    }
    return user.name;
  }
}
